// extracted by mini-css-extract-plugin
export default {"wrapper":"section-info-module--wrapper--a05e2","heading":"section-info-module--heading--6fd43","buttonWrapper":"section-info-module--buttonWrapper--9ae4f"};